import styled, { css } from "styled-components";

export const CheckBoxesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 32px;
`;
export const CheckBox = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  width: calc(33.3333% - 26px);
`;
export const Label = styled.label`
  color: var(--Dark-Blue-100, #002e5c);
  font-feature-settings: "clig" off, "liga" off;
  font-family: var(--MemberDetailsLabelFont-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  margin-top: -4px;
`;
export const CancelButton = styled.button`
  border-radius: 5px;
  background: rgba(37, 85, 239, 0.08);
  display: flex;
  height: 44px;
  width: 91px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-right: 17px;
  color: var(--Blue-100, #2555ef);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
`;
export const ConfirmButton = styled.button`
  border-radius: 5px;
  background: ${(props) =>
    props.isDisabled ? "var(--Gray-20, #F0F0F3)" : "var(--Blue-100, #2555EF)"};
  display: flex;
  height: 44px;
  width: 91px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: ${(props) =>
    props.isDisabled
      ? "var(--Gray-100, #B5B5C3)"
      : "var(--White, var(--White-100, #FFF))"};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  span {
    padding-right: 3px !important;
  }
`;
export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const MergeButton = styled.div`
  margin-left: -17px;
  flex-grow: 1;
  button {
    background: rgba(37, 85, 239, 0.08);
    border-radius: 5px;
    color: var(--Blue-100, #2555ef);
    &:hover {
      background: rgba(37, 85, 239, 0.2);
      color: var(--Blue-100, #2555ef);
    }
  }
`;
export const ContentWrapper = styled.div`
  width: 90%;
  min-height: 530px;
  position: relative;
`;
export const Wrapper = styled.div`
  position: absolute;
  top: 100%;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: end;
  margin-bottom: -50px;
  gap: 15px;
`;
export const MergeInput = styled.div`
  display: flex;
  width: 91%;
  margin-top: 20px;
  margin-left: 40px;
  margin-right: 40px;
`;

export const StatusWrapper = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
height: 100%;
text-transform: capitalize;

`;
export const Status = styled.div`
padding-left: 9.08px;
padding-top: 5.58px;
padding-bottom: 5.58px;
padding-right: 8.5px;
border-radius: 5px;
font-size: 13px;
font-weight: 600;
line-height: 20px;
width: fit-content;
${(props) => (props.type === 'paid' ?
   css`
        color: var(--Blue-100, #2555EF);
        background: var(--Blue-20, #EAEEFC);
      `
    : css`
        color: var(--Pink-100, #FA3372);
        background: var(--Pink-10, #FFF5F8);
              `
  )}
            `

export const CheckBoxWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 46rem;
  span{
    margin-bottom: 6px;

  }
`;